"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateSection = void 0;
const ui_1 = require("@app/component/ui");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const shift_context_1 = require("../shift-context");
const TemplateSection = () => {
    const { formType, copiesCount, setCopiesCount, initialData } = (0, shift_context_1.useShift)();
    if (formType !== 'template') {
        return null;
    }
    if ((0, util_1.isDefined)(initialData?.templateId) && (0, util_1.isDefined)(initialData?.shiftId)) {
        return null;
    }
    return (react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
        react_1.default.createElement(ui_1.Input, { size: "full-width", type: 'number', label: (0, util_1.t)('CYC_EMPS_COUNT'), value: copiesCount, onChange: (v) => setCopiesCount(parseInt(v)), min: 0 }),
        react_1.default.createElement("div", null)));
};
exports.TemplateSection = TemplateSection;
